export default __webpack_public_path__ + "assets/land.e1b5abc7.svg";